let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kLl1H")).then(() => parcelRequire('kn9Jn'));